import React from 'react';

import cn from 'classnames';

import { UiButtonColor, UiButtonVariant } from '@shared/ui/UiButton/index.type';

import styles from './UiButton.module.css';

interface UiButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string;
    variant?: UiButtonVariant;
    btnColor?: UiButtonColor;
    btnText?: string;
    startIcon?: React.ReactNode;
    endIcon?: React.ReactNode;
    type?: 'button' | 'submit' | 'reset';
    innerRef?: React.Ref<HTMLButtonElement> | null;
    btnTextStyles?: string;
}

export const UiButton: React.FC<UiButtonProps> = ({
    className,
    startIcon,
    endIcon,
    btnColor = 'primary',
    btnText,
    type = 'button',
    variant = 'contained',
    innerRef = null,
    btnTextStyles,

    ...restProps
}) => (
    <button
        className={cn(
            styles.uiButton,
            styles[`variant-${variant}`],
            btnColor && styles[`color-${btnColor}`],
            className,
            restProps.disabled && styles.disabled
        )}
        type={type}
        ref={innerRef}
        {...restProps}
    >
        {startIcon && startIcon}
        {variant != 'icon' && btnText && (
            <span className={cn(styles.uiButtonText, btnTextStyles)}>{btnText}</span>
        )}
        {endIcon && endIcon}
    </button>
);
